/**
 *
 * DeleteRegisterPopup
 *
 * @version 1.0.0
 * @author Giuseppe
 * @since 30-Jan-2023
 */

import React from 'react';
import PortalModal from 'Components/PortalModal/PortalModal';
import formattedMessages from '../../modules/languageModule';
import PropTypes from 'prop-types';
import style from './DeleteRegisterPopup.scss';

const DeleteRegisterPopup = (props) => (
	<PortalModal
		className={style.container}
		title={formattedMessages.warning}
		subtitle={formattedMessages.subtitleDelete}
		subtitleValues={formattedMessages.deleteSubtitle}
		actions={{ handleClose: () => {} }}
		buttons={[
			{
				variant: 'outlined',
				onClick: props.actions.closeModal,
				contentText: formattedMessages.abortLabelButton,
			},
			{
				variant: 'contained',
				onClick: () => props.actions.deleteRegister(props.payload),
				contentText: formattedMessages.confirmLabelButton,
				isLoading: props.isLoading,
			},
		]}
	/>
);

DeleteRegisterPopup.propTypes = {
	// Add here some propTypes
	actions: PropTypes.objectOf(PropTypes.func),
	isLoading: PropTypes.bool,
	payload: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
};

DeleteRegisterPopup.defaultProps = {
	// Add here some default propTypes values
	actions: {},
	isLoading: false,
};
export default DeleteRegisterPopup;
